module.exports = "data:image/jpeg;base64,VW5yZWNvZ25pemVkIGlucHV0IGZpbGUgZm9ybWF0IC0tLSBwZXJoYXBzIHlvdSBuZWVkIC10YXJnYQo="